import AllDropdownItem from "../AllDropdownItem/AllDropdownItem";

export default class AllResultsSelectionItem extends AllDropdownItem {
    getSelectedTranslation() {
        return {
            key: `si.${this.translationKeyModifier}.options.all-results.selected-text`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }

    getTranslation() {
        return {
            key: `si.${this.translationKeyModifier}.options.all-results`,
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
